const WIDTH = 992
export default {
  beforeMount() {
    window.addEventListener('resize', this.$_resizeHandler)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_resizeHandler)
  },
  mounted() {
    // 页面加载时也要检测一次设备类型
    this.$_resizeHandler();
  },
  methods: {
    $_isMobile() {
      const rect = document.body.getBoundingClientRect()
      return rect.width - 1 < WIDTH
    },
    $_resizeHandler() {
      if (!document.hidden) {
        const isMobile = this.$_isMobile()
        // 修正：将布尔值转换为对应的字符串
        this.$store.commit("changeDevice", isMobile ? 'mobile' : 'desktop');
      }
    }
  }
}